/* 
  It formats a number based on the locale.
  
  Examples:

  Number: 10000    |  Number: 10000    
  Locale: en-US    |  Locale: nb-NO
  -----------------+-----------------
  Result: 10,000   |  Result: 10 000 
*/
export const formatNumber = (number: number, locale: string) => {
  return new Intl.NumberFormat(locale).format(number)
}

/**
 * Formats a score number with locale-appropriate formatting and unit display.
 * Uses Intl.NumberFormat for consistent number formatting.
 *
 * @param score - The score number to format
 * @param locale - The locale for number formatting
 * @param unitTranslation - The translated unit text (e.g., "Points", "Punkte", etc.)
 *
 * Examples:
 * formatScore(1500, 'en-US', 'Points') => "1,500 Points"
 * formatScore(1500, 'de-DE', 'Punkte') => "1.500 Punkte"
 * formatScore(1500, 'fr-FR', 'Points') => "1 500 Points"
 */
export const formatScore = (
  score: number,
  locale: string,
  unitTranslation: string
) => {
  // Format the number according to locale
  const formattedNumber = new Intl.NumberFormat(locale).format(score)

  // Combine formatted number with localized unit
  return `${formattedNumber} ${unitTranslation}`
}
